import { registerRemotes } from '@module-federation/enhanced/runtime';

type TRemotes = Record<string, string>;

fetch('/module-federation.manifest.json')
  .then((res) => {
    if (!res.ok) throw new Error(`Failed to load remote manifest: ${res.status}`);
    return res.json();
  })
  .then((remotes: TRemotes) => {
    const updated = getUpdatedRemotes(remotes);
    return Object.entries(updated).map(([name, entry]) => ({ name, entry }));
  })
  .then((remotes) => registerRemotes(remotes))
  .then(() => import('./bootstrap').catch((err) => console.error(err)));

// On a deployed (non-localhost) host, every remote is served same-origin under
// /apps/<name>/ — Option A: the shell host and its remotes (auth,
// application-catalog, settings) live in one bucket. This lets the committed
// manifest keep its localhost dev URLs while the rewrite handles deployed hosts.
function getUpdatedRemotes(remotes: TRemotes): TRemotes {
  const currentHost = window.location.host;
  if (currentHost.includes('localhost')) return remotes;
  return Object.entries(remotes).reduce((acc, [name, url]) => {
    try {
      const remoteUrl = new URL(url);
      remoteUrl.host = currentHost;
      remoteUrl.port = '';
      remoteUrl.protocol = 'https';
      remoteUrl.pathname = `/apps/${name}${remoteUrl.pathname}`;
      acc[name] = remoteUrl.toString();
    } catch (error) {
      console.error(`Failed to update remote URL for "${name}": ${url}.`, error);
      acc[name] = url;
    }
    return acc;
  }, {} as TRemotes);
}
